import React from "react";
import Slider from "react-slick";
import "./slider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { sliderData } from "../../assets/data";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className="control-btn" onClick={onClick}>
      <button className="next">
        <i className="fas fa-light fa-circle-right"></i>
      </button>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="control-btn" onClick={onClick}>
      <button className="prev">
        <i className="fas fa-light fa-circle-left"></i>
      </button>
    </div>
  );
}

const SlickSlider = () => {
  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="slickSlider">
      <div className="container">
        <Slider {...settings}>
          {sliderData.map((item) => {
            return (
              <div className="slider-items" key={item?.id}>
                <img src={item?.image} alt="userphoto" />
                <h6 className="slider-item-name">{item?.name}</h6>
                <h6 className="slider-item-title">{item?.title}</h6>
                <p className="slider-item-desc"> {item?.description} </p>
                <h6 className="slider-item-point"> {item?.point} </h6>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default SlickSlider;
